/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
// import 'date-fns';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// import moment from 'moment';
import useDebounce from '../../../utils/useDebounce';

const Toolbar = (props) => {
  const {
    // setCommentId,
    // setPostSlugName,
    // setuserId,
    // setNickname,
    // setCommentText,
    // setCreatedAt,
    // setHasBadge,
    deleted,
    setDeleted,
    censored,
    setCensored,
    setSearchPostSlugName,
    setSearchCommentText,
    setSearchNickname,
    setStartDate,
    setFinishDate,
  } = props;


  const [searchPostSlugNameTyped, setSearchPostSlugNameTyped] = useState(null);
  const debouncedSearchPostSlugName = useDebounce(searchPostSlugNameTyped, 500);
  useEffect(() => {
    setSearchPostSlugName(searchPostSlugNameTyped);
  }, [debouncedSearchPostSlugName]);

  const [searchCommentTextTyped, setSearchCommentTextTyped] = useState(null);
  const debouncedSearchCommentText = useDebounce(searchCommentTextTyped, 500);
  useEffect(() => {
    setSearchCommentText(searchCommentTextTyped);
  }, [debouncedSearchCommentText]);

  const [searchNicknameTyped, setSearchNicknameTyped] = useState(null);
  const debouncedSearchNickname = useDebounce(searchNicknameTyped, 500);
  useEffect(() => {
    setSearchNickname(searchNicknameTyped);
  }, [debouncedSearchNickname]);

  const [startDateSearch, setStartDateSearch] = useState(null);
  const debouncedStartDate = useDebounce(startDateSearch, 500);
  useEffect(() => {
    const date = new Date(new Date(startDateSearch).toDateString());
    if (startDateSearch === '' || (date instanceof Date && !Number.isNaN(date.valueOf()))) {
      setStartDate(startDateSearch);
    }
  }, [debouncedStartDate]);

  const [finishDateSearch, setFinishDateSearch] = useState(null);
  const debouncedFinalDate = useDebounce(finishDateSearch, 500);
  useEffect(() => {
    const date = new Date(new Date(finishDateSearch).toDateString());
    if (finishDateSearch === '' || (date instanceof Date && !Number.isNaN(date.valueOf()))) {
      setFinishDate(finishDateSearch);
    }
  }, [debouncedFinalDate]);

  // const handleChangeRange = (event, newValue) => {
  //   rangeSetValue(newValue);
  // };
  // const setRangeFilter = (event, newValue) => {
  //   setPriceFilter(newValue);
  // };

  return (
    <div className="flex">

      <div className="flex w-1/6 my-6 items-center">
        <label htmlFor="toggle" className="block uppercase tracking-wide text-gray-700 text-xs font-bold mr-2">Only Deleted</label>
        <div className="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
          <input
            type="checkbox"
            name="toggle"
            id="toggle"
            value={deleted}
            onChange={() => setDeleted(!deleted)}
            checked={deleted}
            className="outline-none toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
          />
          <label htmlFor="toggle" className="toggle-label block overflow-hidden h-6 rounded-full bg-grey cursor-pointer" />
        </div>
      </div>

      <div className="flex w-1/6 my-6 items-center">
        <label htmlFor="toggle" className="block uppercase tracking-wide text-gray-700 text-xs font-bold mr-2">Only Censored</label>
        <div className="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
          <input
            type="checkbox"
            name="toggle"
            id="toggle"
            value={censored}
            onChange={() => setCensored(!censored)}
            checked={censored}
            className="outline-none toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
          />
          <label htmlFor="toggle" className="toggle-label block overflow-hidden h-6 rounded-full bg-grey cursor-pointer" />
        </div>
      </div>

      <div className="w-1/5 px-3 md:mb-0">
        <label
          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          htmlFor="searchPostSlugNameTyped"
        >
          Post slug name
        </label>
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="searchPostSlugNameTyped"
          type="text"
          onChange={e => setSearchPostSlugNameTyped(e.target.value)}
          value={searchPostSlugNameTyped}
        />
      </div>

      <div className="w-1/5 px-3 md:mb-0">
        <label
          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          htmlFor="searchCommentTextTyped"
        >
          Search in Comments
        </label>
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="searchCommentTextTyped"
          type="text"
          onChange={e => setSearchCommentTextTyped(e.target.value)}
          value={searchCommentTextTyped}
        />
      </div>

      <div className="w-1/5 px-3 md:mb-0">
        <label
          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          htmlFor="searchNicknameTyped"
        >
          Nickname
        </label>
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="searchNicknameTyped"
          type="text"
          onChange={e => setSearchNicknameTyped(e.target.value)}
          value={searchNicknameTyped}
        />
      </div>

      <div className="w-1/5 px-3 md:mb-0">
        <label
          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          htmlFor="startDateSearch"
        >
          Start Date (yyyy-mm-dd)
        </label>
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="startDateSearch"
          type="text"
          onChange={e => setStartDateSearch(e.target.value)}
          value={startDateSearch}
        />
      </div>

      <div className="w-1/5 px-3 md:mb-0">
        <label
          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          htmlFor="finishDateSearch"
        >
          Final Date (yyyy-mm-dd)
        </label>
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="finishDateSearch"
          type="text"
          onChange={e => setFinishDateSearch(e.target.value)}
          value={finishDateSearch}
        />
      </div>

    </div>
  );
};

Toolbar.propTypes = {
  // setCommentId: PropTypes.func.isRequired,
  // setPostSlugName: PropTypes.func.isRequired,
  // setuserId: PropTypes.func.isRequired,
  // setNickname: PropTypes.func.isRequired,
  // setCommentText: PropTypes.func.isRequired,
  // setCreatedAt: PropTypes.func.isRequired,
  // setHasBadge: PropTypes.func.isRequired,
  deleted: PropTypes.bool.isRequired,
  setDeleted: PropTypes.func.isRequired,
  censored: PropTypes.bool.isRequired,
  setCensored: PropTypes.func.isRequired,
  setSearchPostSlugName: PropTypes.func.isRequired,
  setSearchCommentText: PropTypes.func.isRequired,
  setSearchNickname: PropTypes.func.isRequired,
  setStartDate: PropTypes.func.isRequired,
  setFinishDate: PropTypes.func.isRequired,
};

Toolbar.defaultProps = {
  // startDate: null,
  // finishDate: null,
};

export default Toolbar;
